$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [data-testid="GooglePay-button"] , [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        Swal.fire({
          title: 'Términos y condiciones',
          input: 'checkbox',
          inputValue: 0,
          inputPlaceholder:
          '<p style="text-align:left;">Acepto las <a href="/policies/terms-of-service" target="_blank">condiciones generales</a> y la <a href="/policies/privacy-policy" target="_blank">política de privacidad</a></p>',
          confirmButtonText:
            'Continuar&nbsp;<i class="fa fa-arrow-right"></i>',
          confirmButtonColor: "#115c8c",
          inputValidator: (result) => {
            if (result.isConfirmed || result) {
              document.location.href = '/cart/checkout';
            } else {
              return 'Debes aceptar para poder continuar'
            }
          }
        });
        return false;
      }
    });
  });